<template>
  <div class="page-owners-associations-documents">
    <div class="documents-index">
      <div class="container">

        <!--
        <router-link
            class="menu-item"
            :to="{ name: 'inicio', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">

            <span class="menu-icon">
              <img src="@/assets/img/icons/panel-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Panel</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

        <router-link
            class="menu-item"
            :to="{ name: 'expensas', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">

            <span class="menu-icon">
              <img src="@/assets/img/icons/expensas-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Expensas</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

        <router-link
            class="menu-item"
            :to="{ name: 'noticias', params: { owners_association_id: owners_association.id } }"
        style="text-decoration: none;"
        >
          <div class="menu-content">

            <span class="menu-icon">
              <img src="@/assets/img/icons/noticias-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Noticias</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>
-->
        <router-link
            class="menu-item"
            :to="{ name: 'documentos', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">
            <span class="menu-icon">
              <img src="@/assets/img/icons/documentos-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Documentos</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

        <!-- 🔹 Amenities -->
        <router-link
            class="menu-item"
            :to="{ name: 'listado-amenities', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">
            <span class="menu-icon">
              <img src="@/assets/img/icons/amenities-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Amenities</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

        <!-- 🔹 Teléfonos útiles -->
        <router-link
            class="menu-item"
            :to="{ name: 'telefonos-utiles', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">
            <span class="menu-icon">
              <img src="@/assets/img/icons/telefonos-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Teléfonos Útiles</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

        <!-- 🔹 Votaciones -->
        <router-link
            class="menu-item"
            :to="{ name: 'votaciones', params: { owners_association_id: owners_association.id } }"
            style="text-decoration: none;"
        >
          <div class="menu-content">
            <span class="menu-icon">
              <img src="@/assets/img/icons/votaciones-menu.svg" alt="icon" class="icon-left" />
            </span>

            <div class="menu-text">
              <p class="menu-title">Votaciones</p>
            </div>

            <span class="menu-chevron">
              <img src="@/assets/img/icons/chevron-right.svg" alt=">" class="chevron-icon" />
            </span>
          </div>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import OwnersAssociationHeader from '@/components/Layouts/OwnersAssociationHeader';

export default {
  name: 'Menu',
  components: { OwnersAssociationHeader },
  props: ['owners_association'],
  computed: {
    is_capacitor() {
      return (
          Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android'
      );
    },
  },
};
</script>

<style >
.menu-item {
  display: block;
  padding: 2rem 1rem;
  text-decoration: none;
  color: inherit;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  transition: background 0.2s ease;
  cursor: pointer;
  margin-bottom: 0.8rem;
}

.menu-item:hover {
  background: #f9f9f9;
}

.menu-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 🔹 Ícono izquierda */
.menu-icon {
  color: #000000;
  flex-shrink: 0;
  margin-right: 10px;
}

.icon-left {
  width: 20px;
  height: 20px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.menu-item:hover .icon-left {
  opacity: 1;
}
.chevron-left { position: absolute; left: 16px; width: 20px; height: 20px; opacity: 0.7; cursor: pointer; transition: transform 0.2s ease, opacity 0.2s ease; }
.menu-text {
  flex-grow: 1;
  overflow: hidden;
}

.menu-title {
  color: #000000;
  font-size: 0.875rem;
  margin:0;

}

/* 🔹 Chevron derecha */
.menu-chevron {
  display: flex;
  color: #000000;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chevron-icon {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.menu-item:hover .chevron-icon {
  opacity: 1;
  transform: translateX(3px);
  filter: brightness(0) saturate(100%) invert(33%) sepia(98%) saturate(1260%)
  hue-rotate(191deg) brightness(97%) contrast(92%);
}
</style>
